<template>
  <div>
    <b-card no-body class="p-2 container-card">
      <b-row>
        <b-col cols="12" class="px-2">
          <div>
            <div class="d-flex justify-content-end mb-1" v-if="isShowCreateBtn">
              <add-button
                v-if="getPermissionModule('Privileges').adjust"
                :btn-label="'Create Campaign'"
                @click.native="openCodeTemplateModal"
              />
            </div>
            <div class="d-flex flex-wrap justify-content-end">
              <div class="mr-1 ml-1 mb-1">
                <v-select
                  id="privilege-type-status"
                  class="v-select-filter bg-dropdown"
                  placeholder="Status"
                  :options="statusOption"
                  @input="(option) => onSelectFilter('status', option)"
                />
              </div>
              <div class="search-container mb-1">
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :fields="fields"
                :items="codeTemplateTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table"
              > -->
              <b-table
                :fields="fields"
                :items="codeTemplateTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                no-local-sorting
                class="default-static-table-vertical"
              >
                <template #cell(no)="data">
                  <span>{{ data.index + 1 }}</span>
                </template>
                <template #cell(seq)="data">
                  <div class="text-center">
                    {{ data.item.seq }}
                  </div>
                </template>
                <template #head(title)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(title)="data">
                  <div class="text-center">
                    {{ data.item.title }}
                  </div>
                </template>
                <template #head(privilege)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(privilege)="data">
                  <div class="text-center">
                    {{ data.item.privilege }}
                  </div>
                </template>
                <template #head(valid_from)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(valid_from)="data">
                  <div class="text-center">
                    {{ resolveDateWithSeperator(data.item.valid_from) }}
                  </div>
                  <div class="text-center">
                    {{ resolveTime(data.item.valid_from) }}
                  </div>
                </template>
                <template #head(valid_through)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(valid_through)="data">
                  <div class="text-center">
                    {{ resolveDateWithSeperator(data.item.valid_through) }}
                  </div>
                  <div class="text-center">
                    {{ resolveTime(data.item.valid_through) }}
                  </div>
                </template>
                <template #head(expire_date)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(expire_date)="data">
                  <div class="text-center">
                    {{
                      data.item.expire_date
                        ? resolveDateWithSeperator(data.item.expire_date)
                        : "-"
                    }}
                  </div>
                  <div class="text-center" v-if="data.item.expire_date">
                    {{
                      data.item.expire_date
                        ? resolveTime(data.item.expire_date)
                        : "-"
                    }}
                  </div>
                </template>
                <template #cell(status)="data">
                  <b-form-checkbox
                    field-value="true"
                    class="custom-control-success"
                    name="check-button"
                    switch
                    :checked="data.item.status == statusAction.ACTIVE"
                    @change="onChangeStatus($event, data.item)"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(actions)="data">
                  <action-group
                    v-if="getPermissionModule('Privileges').adjust"
                    :resolve-action="resolveMappingTableAction"
                    :set-action-list="codeTemplateActionList"
                    :item-data="data"
                  />
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
    <code-template-modal
      v-if="modalType.codeTemplate"
      @onCloseModal="closeCodeTemplateModal"
    />
    <copy-link-modal
      v-if="modalType.copyLink && urlDataLink"
      :urlLink="urlDataLink"
      @onCloseModal="closeCopyLinkModal"
    />
    <preview-modal
      v-if="modalType.previewModal"
      @onCloseModal="closePreviewModal"
      :templateId="template_Id"
    />
    <export-code-info-modal
      v-if="modalType.exportCodeInfoModal"
      @onCloseModal="closeExportInfoModal"
      :templateId="template_Id"
      :templateData="template_Data"
    />
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";

import useCodeTemplateList from "./hooks/useCodeTemplateList";
import CodeTemplateModal from "./components/CodeTemplateModal";
import CopyLinkModal from "./components/CopyLinkModal.vue";
import PreviewModal from "./components/PreviewModal.vue";
import ExportCodeInfoModal from './components/ExportCodeInfoModal.vue'

import useCodeTemplate from "../code-template-info/hooks/useCodeTemplate";


export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    ActionGroup,
    AddButton,
    Search,
    vSelect,
    PaginationWithReorder,
    CodeTemplateModal,
    CopyLinkModal,
    PreviewModal,
    ExportCodeInfoModal,
  },
  setup() {
    const {
      loading,
      fields,
      statusOption,
      codeTemplateTable,
      pagination,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,

      codeTemplateActionList,
      modalType,
      openCodeTemplateModal,
      closeCodeTemplateModal,
      closeCopyLinkModal,
      resolveMappingTableAction,
      resolveDateWithSeperator,
      resolveTime,
      removeCodeTemplate,
      closePreviewModal,
      closeExportInfoModal,
      template_Id,
      template_Data,
      urlDataLink,
      isShowCreateBtn,
      statusAction,
      onChangeStatus,
      getPermissionModule
    } = useCodeTemplateList();

    return {
      loading,
      fields,
      statusOption,
      codeTemplateTable,
      pagination,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,

      codeTemplateActionList,
      modalType,
      openCodeTemplateModal,
      closeCodeTemplateModal,
      closeCopyLinkModal,
      resolveMappingTableAction,
      resolveDateWithSeperator,
      resolveTime,
      removeCodeTemplate,
      closePreviewModal,
      closeExportInfoModal,
      template_Id,
      template_Data,
      urlDataLink,
      isShowCreateBtn,
      statusAction,
      onChangeStatus,
      getPermissionModule
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/status.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/v-select.css";
</style>
